import { CustomerUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type FetchListAllModel = {
  page?: number
}

type FilterCustomerModel = {
  page?: number
  name?: string
  cpf?: number | string
}

export const fetchListAll = ({ page = 1 }: FetchListAllModel) => {
  return new CustomerUseCase(`/clientes/page/${page}`, makeAxiosHttpClient())
}

export const filterCustomer = ({
  page = 1,
  name,
  cpf
}: FilterCustomerModel) => {
  return new CustomerUseCase(
    `/clientes/filterSearchConsumer?nome=${name}&cpf=${cpf}&pagina=${page}`,
    makeAxiosHttpClient()
  )
}
